import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const features=[
  {icon: FiIcons.FiCompass,title: 'New students welcome',text: 'Step-by-step guidance for first-time learners building strong, safe driving foundations in an automatic car.'},
  {icon: FiIcons.FiFlag,title: 'Test-ready students welcome',text: 'Focused preparation and mock practice to help you approach your NSW driving test with confidence.'},
  {icon: FiIcons.FiHeart,title: 'Calm & supportive',text: 'Patient, stress-free instruction shaped around your individual learning pace.'},
  {icon: FiIcons.FiShield,title: 'Automatic-only instruction',text: 'Every lesson is in a modern, safe automatic dual-control vehicle.'}
];

function FeatureGrid() {
  return (
    <section className="features-section section-pad" id="lessons">
      <div className="page-width">
        <div className="section-heading centered">
          <span className="eyebrow">Automatic driving lessons</span>
          <h2>Feel at ease from your <span>first lesson.</span></h2>
          <p>Learn the skills NSW learners need, with instruction that meets you where you are.</p>
        </div>
        <div className="feature-grid">
          {features.map((feature,index)=> (
            <motion.article className="feature-card" key={feature.title} initial={{opacity: 0,y: 18}} whileInView={{opacity: 1,y: 0}} viewport={{once: true,amount: 0.2}} transition={{duration: 0.4,delay: index * 0.08}}>
              <div className="feature-icon"><SafeIcon icon={feature.icon} /></div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
              <span className="feature-number">0{index + 1}</span>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeatureGrid;